import React from 'react';
import cls from 'classnames';
import styles from '../../styles.module.scss';

interface ITabBa {
  onChange: (value: string) => void;
  activeTab?: string;
  tabList: {
    label: string;
    value: string;
  }[];
}
const TabBar: React.FC<ITabBa> = ({ onChange, activeTab, tabList }) => {
  return (
    <div className=" mx-auto mb-7 inline-block whitespace-nowrap  rounded-xl bg-white p-1 text-base shadow-wk1  md:mb-12 md:overflow-visible md:rounded-3xl md:p-3 xl:mb-15 xl:text-xl">
      {tabList?.map?.((item) => (
        <h3
          key={item.value}
          onClick={() => onChange(item.value)}
          className={cls(
            ' mr-3 inline-block min-w-[116px] shrink-0 cursor-pointer rounded-xl border-2 bg-[linear-gradient(180deg,_rgba(255,_255,_255,_0.45)_0%,rgba(255,_255,_255,_0.6)_105%)] px-4 py-[10px] text-center text-[16px] backdrop-blur-[4px] last:mr-0 md:rounded-2xl md:px-8 md:py-[14px]  lg:bg-none lg:text-xl lg:shadow-none lg:backdrop-blur-none xl:py-[16px] xl:text-[28px]',
            item.value === activeTab
              ? 'border-white font-bold [&&]:bg-[linear-gradient(90deg,_rgba(255,_83,_83,_0.08)_9%,rgba(109,_56,_251,_0.08)_61%,rgba(0,_157,_255,_0.08)_100%),_linear-gradient(180deg,_rgba(255,_255,_255,_0.7)_0%,rgba(255,_255,_255,_0.95)_105%)]'
              : 'border-transparent font-semibold',
          )}
        >
          <span
            className={cls({ [styles.badgeTabText]: item.value === activeTab })}
            dangerouslySetInnerHTML={{ __html: item.label }}
          />
        </h3>
      ))}
    </div>
  );
};

export default TabBar;
